export default "__VITE_ASSET__BbbcvZrS__"